<p-dialog [(visible)]="isRejectChangeRequestModal" [style]="{width: '40vw'}" (onHide)="cancel()" [modal]="true">

    <div *ngIf="errorMessages.length > 0">
        <p-messages severity="error">
          <ng-template pTemplate>
            <span class="p-message-icon pi pi-times-circle"></span>
            <span class="p-ml-2">Please correct the following errors.</span>
            <ul>
              <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
            </ul>
          </ng-template>
        </p-messages>
      </div>
    <ng-template pTemplate="header">
        <b>Reject Change Request Item</b>
    </ng-template>

    <div class="field field-required">
      <bpt-dropdown label="Reason for Rejection*" [(ngModel)]="reasonForRejection"
        [editable]="false" id="reasonForRejection" [options]="rejectReasonsData"
        [showClear]="true" [showFilter]="true" [valueField]="labelField" [labelField]="labelField"
        [ngClass]="{'error-highlight' : mandatoryFields.reasonForRejection}">
      </bpt-dropdown>
    </div>
    
    <div class="field">
      <bpt-text-input [highlightAllOnFocus]="true" 
      [multiLine]="true" id="reviewerComment" label="Reviewer Comment (optional)" 
      [(ngModel)]="reviewerComment"></bpt-text-input>
    </div>

    <ng-template pTemplate="footer">
        <p-button appPreventDoubleClick label="Confirm" id="confirm" (debounceClick)="confirmChangeRequestRejection()"></p-button>
        <p-button appPreventDoubleClick styleClass="p-button-outlined" label="Cancel" id="cancel" (debounceClick)="cancel()"></p-button>
    </ng-template>
</p-dialog>
